var map = {
	"./cliente 1.JPG": 5422,
	"./cliente 10.JPG": 3012,
	"./cliente 2.PNG": 5777,
	"./cliente 3.JPG": 2732,
	"./cliente 4.PNG": 7879,
	"./cliente 5.PNG": 9086,
	"./cliente 6.PNG": 2661,
	"./cliente 7.PNG": 28,
	"./cliente 8.PNG": 7291,
	"./cliente 9.PNG": 6674
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3474;